export const fields = [{
	type: "email",
	name: "email",
	label: "E-mail",
	autoComplete: "username",
	required: true,
	icon: "envelope",
}]
